import { getField, updateField } from 'vuex-map-fields'
import router from '../../router'

export default{
  namespaced: true,
  state: {
    startDate: '',
    endDate: '',
    orderAry: [],
    basketref: '',
    ordernumber: null
  },
  actions: {
    getBasketRef ({commit}) {
      /* 2022/10/04, jamei
      let ca = document.cookie.split(';')
      let tempbasketref = ''
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        if (c.charAt(0) === ' ') {
          c = c.substring(1, c.length)
          if (c.includes('')) {
            tempbasketref = c
          }
        }
      }
      let basketref = tempbasketref.replace('mawebhlbr=', '')
      */
      let basketref = window.tpxReadCookie('mawebhlbr')
      commit('setBasketref', {basketref})
    },
    getOrder ({commit, state, dispatch}) {
      dispatch('getBasketRef')
      if (state.basketref === '') {
        let message = '請先登入'
        let theme = 'danger'
        commit('changeMessage', {message, theme}, {root: true})
        router.push('/')
        return
      }
      if (state.startDate === '' || state.endDate === '') {
        let message = '請選擇搜尋區間'
        let theme = 'primary'
        commit('changeMessage', {message, theme}, {root: true})
        return
      }
      commit('LOADING', true, {root: true})
      let API_PATH = process.env.API
      let token = state.basketref
      // let orderNumber = state.ordernumber
      fetch(`${API_PATH}pdfwkflow/getorders/${token}/${state.startDate}/${state.endDate}`, {method: 'POST'}).then(res => {
        return res.json()
      }).then(result => {
        commit('getOrder', {result})
      }).finally(() => {
        commit('LOADING', false, {root: true})
      })
    },
    init ({commit, state, dispatch}) {
      dispatch('getBasketRef')
      if (state.basketref === '') {
        alert('請先登入')
        router.push('/')
        return
      }
      commit('LOADING', true, {root: true})
      let today = new Date()
      let time = today.getTime()
      // use timestamp count timestamp of a thirty days ago
      let oneMonthAgoTimeStamp = time - 86400000 * 30
      let oneMonthAgoDate = new Date(oneMonthAgoTimeStamp)
      let y = today.getFullYear()
      let ly = oneMonthAgoDate.getFullYear()
      /* 2022/09/16, jamei
      let m = (today.getMonth() + 1 < 10) ? '0' + today.getMonth() + 1 : today.getMonth() + 1
      let lm = (oneMonthAgoDate.getMonth() + 1 < 10) ? '0' + oneMonthAgoDate.getMonth() + 1 : oneMonthAgoDate.getMonth() + 1
      */
      let m = (today.getMonth() + 1 < 10) ? '0' + parseInt(today.getMonth() + 1) : parseInt(today.getMonth() + 1)
      let lm = (oneMonthAgoDate.getMonth() + 1 < 10) ? '0' + parseInt(oneMonthAgoDate.getMonth() + 1) : parseInt(oneMonthAgoDate.getMonth() + 1)
      let date = (today.getDate() < 10) ? '0' + today.getDate() : today.getDate()
      let ldate = (oneMonthAgoDate.getDate() < 10) ? '0' + oneMonthAgoDate.getDate() : oneMonthAgoDate.getDate()
      let endDate = `${y}-${m}-${date}`
      let startDate = `${ly}-${lm}-${ldate}`
      let token = state.basketref
      // let orderNumber = state.ordernumber
      let API_PATH = process.env.API
      commit('setDate', {startDate, endDate})
      fetch(`${API_PATH}pdfwkflow/getorders/${token}/${startDate}/${endDate}`, {method: 'POST'}).then(res => {
        return res.json()
      }).then(result => {
        commit('getOrder', {result})
      }).catch((error) => {
        console.error(error)
      }).finally(() => {
        commit('LOADING', false, {root: true})
      })
    }
  },
  mutations: {
    updateField,
    setDate (state, {startDate, endDate}) {
      state.startDate = startDate
      state.endDate = endDate
    },
    setBasketref (state, {basketref}) {
      state.basketref = basketref
    },
    getOrder (state, {result}) {
      state.orderAry = result
      console.log(result)
    }
  },
  getters: {
    getField
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/orderSearch.js